







import { Component, Vue } from "vue-property-decorator";
import AppNavigation from "./AppNavigation.vue";
import { AuthModule } from "@/store/auth.module";

@Component({
  components: {
    AppNavigation,
  },
})
export default class AppMain extends Vue {
  loading = true;
  public async created() {
    this.loading = true;
    await this.boostrap();
    this.loading = false;
  }

  async boostrap() {
    await AuthModule.getUser();
  }
}
